import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataAccountTypesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromAccountTypesReducer.accountTypesFeatureKey]
);

export const getStaticDataAccountTypesFailure = createSelector(
  getStaticDataAccountTypesState,
  staticDataCountriesReducer.fromAccountTypesReducer.getAccountTypesError
);

export const getStaticDataAccountTypesResponse = createSelector(
  getStaticDataAccountTypesState,
  staticDataCountriesReducer.fromAccountTypesReducer.getAccountTypes
);
